import Auth from '@aws-amplify/auth'
import type { Config } from '../../config'
import { constants } from '../constants'

let explicitSignOut = false

function recoveryUrl() {
  const current = new URL(window.location.href)
  if (current.searchParams.has('code') || current.searchParams.has('error')) {
    // Never replay an OAuth callback. Resume the saved launch, if available.
    try {
      const saved = new URL(
        localStorage.getItem('redirectAfterAuth') || '/',
        current.origin,
      )
      if (
        saved.origin === current.origin &&
        saved.pathname.replace(/\/+$/, '') !== '/logout' &&
        !saved.searchParams.has('code') &&
        !saved.searchParams.has('error')
      ) {
        return saved.href
      }
    } catch {
      // A stale or malformed return route must not block authentication.
    }
    return current.origin + '/'
  }
  return current.href
}

export function getAuthReturnRoute() {
  const destination = new URL(recoveryUrl())
  return destination.pathname + destination.search
}

export function withSessionRecovery(config: Config['amplifyConfig']) {
  const oauth = config.Auth.oauth
  return {
    ...config,
    Auth: {
      ...config.Auth,
      oauth: {
        ...oauth,
        urlOpener: async (url: string) => {
          const destination = new URL(url)
          const isHostedLogout =
            destination.origin === `https://${oauth.domain}` &&
            destination.pathname === '/logout'

          if (
            isHostedLogout &&
            !explicitSignOut &&
            window.location.pathname.replace(/\/+$/, '') !== '/logout'
          ) {
            // Amplify 5 clears the invalid Cognito user before opening /logout.
            // Reload locally so App can federate again, without reaching Bright's
            // central logout endpoint (which also terminates Matrix sessions).
            localStorage.removeItem(constants.TOKEN_FIELD)
            localStorage.removeItem(constants.AUTHENTICATION_FIELD)
            url = recoveryUrl()
          }

          // Match Amplify's browser opener for sign-in and intentional sign-out.
          const opened = window.open(url, '_self')
          if (!opened) throw new Error('Unable to navigate for authentication')
          return opened
        },
      },
    },
  }
}

export async function signOut() {
  explicitSignOut = true
  try {
    await Auth.signOut()
  } finally {
    explicitSignOut = false
  }
}
